import React from 'react';

const Enkaku2026Page: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="w-full">
        <picture>
          <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/fv_pc.jpg" />
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/fv_sp.png" 
            alt="七福神遠隔ヒーリング&アクティベーション" 
            className="w-full h-auto"
          />
        </picture>
      </section>

      <main>
        {/* Image Section 01 */}
        <section className="w-full">
          <picture>
            <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/img_01.jpg" />
            <img 
              src="https://keikoanaguchi.com/2026enkaku/images/img_01_sp.png" 
              alt="" 
              className="w-full h-auto"
            />
          </picture>
        </section>

        {/* CTA Section */}
        <section className="w-full bg-gradient-to-b from-pink-50 to-white py-12">
          <div className="max-w-2xl mx-auto px-4">
            <a 
              href="https://dynavision.shop/shopdetail/000000003279" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block mb-8 hover:opacity-90 transition-opacity"
            >
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/btn.png" 
                alt="お申し込みはこちら" 
                className="w-full h-auto max-w-md mx-auto"
              />
            </a>
            <div className="flex justify-center gap-6 text-sm">
              <a 
                href="https://dynavision.co.jp/html/Disclaimer.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                免責事項
              </a>
              <a 
                href="https://dynavision.co.jp/html/cancellation.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                キャンセル規定
              </a>
              <a 
                href="https://dynavision.co.jp/sub04_03.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
        </section>

        {/* Image Section 02 */}
        <section className="w-full">
          <picture>
            <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/img_02.jpg" />
            <img 
              src="https://keikoanaguchi.com/2026enkaku/images/img_02_sp.png" 
              alt="" 
              className="w-full h-auto"
            />
          </picture>
        </section>

        {/* Image Section 03 */}
        <section className="w-full">
          <picture>
            <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/img_03.jpg" />
            <img 
              src="https://keikoanaguchi.com/2026enkaku/images/img_03_sp.png" 
              alt="" 
              className="w-full h-auto"
            />
          </picture>
        </section>

        {/* Image Section 04 */}
        <section className="w-full">
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_04.jpg" 
            alt="" 
            className="w-full h-auto hidden md:block"
          />
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_04_sp.png" 
            alt="" 
            className="w-full h-auto md:hidden"
          />
        </section>

        {/* Image Section 05 */}
        <section className="w-full">
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_05.jpg" 
            alt="" 
            className="w-full h-auto hidden md:block"
          />
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_05_sp.png" 
            alt="" 
            className="w-full h-auto md:hidden"
          />
        </section>

        {/* Image Section 06 */}
        <section className="w-full">
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_06.jpg" 
            alt="" 
            className="w-full h-auto hidden md:block"
          />
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_06_sp.png" 
            alt="" 
            className="w-full h-auto md:hidden"
          />
        </section>

        {/* Image Section 07 */}
        <section className="w-full">
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_07.jpg" 
            alt="" 
            className="w-full h-auto hidden md:block"
          />
        </section>

        {/* Image Section 08 */}
        <section className="w-full">
          <img 
            src="https://keikoanaguchi.com/2026enkaku/images/img_08.jpg" 
            alt="" 
            className="w-full h-auto hidden md:block"
          />
        </section>

        {/* Contents Section */}
        <section className="w-full bg-gradient-to-b from-white to-pink-50 py-12">
          <div className="max-w-4xl mx-auto px-4">
            <picture>
              <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/content_img.png" />
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/content_img_sp.png" 
                alt="コンテンツ内容" 
                className="w-full h-auto mb-8"
              />
            </picture>
            <picture>
              <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/price_img.png" />
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/price_img_sp.png" 
                alt="料金" 
                className="w-full h-auto mb-8"
              />
            </picture>
            <picture>
              <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/qa_img.png" />
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/qa_img_sp.png" 
                alt="よくある質問" 
                className="w-full h-auto"
              />
            </picture>
          </div>
        </section>

        {/* Cancel Section */}
        <section className="w-full bg-white py-12">
          <div className="max-w-4xl mx-auto px-4">
            <picture>
              <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/alert_img.png" />
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/alert_img_sp.png" 
                alt="注意事項" 
                className="w-full h-auto"
              />
            </picture>
          </div>
        </section>

        {/* Profile Section */}
        <section className="w-full bg-gradient-to-b from-pink-50 to-white py-12">
          <div className="max-w-4xl mx-auto px-4">
            <picture>
              <source media="(min-width: 768px)" srcSet="https://keikoanaguchi.com/2026enkaku/images/profile_img.png" />
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/profile_img_sp.png" 
                alt="プロフィール" 
                className="w-full h-auto"
              />
            </picture>
          </div>
        </section>

        {/* Bottom CTA Section */}
        <section className="w-full bg-gradient-to-b from-white to-pink-50 py-12">
          <div className="max-w-2xl mx-auto px-4">
            <a 
              href="https://dynavision.shop/shopdetail/000000003279" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block mb-8 hover:opacity-90 transition-opacity"
            >
              <img 
                src="https://keikoanaguchi.com/2026enkaku/images/btn.png" 
                alt="お申し込みはこちら" 
                className="w-full h-auto max-w-md mx-auto"
              />
            </a>
            <div className="flex justify-center gap-6 text-sm">
              <a 
                href="https://dynavision.co.jp/html/Disclaimer.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                免責事項
              </a>
              <a 
                href="https://dynavision.co.jp/html/cancellation.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                キャンセル規定
              </a>
              <a 
                href="https://dynavision.co.jp/sub04_03.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Enkaku2026Page;